import { render } from "./CertDetailDec2025Page.vue?vue&type=template&id=2897a9c2"
import script from "./CertDetailDec2025Page.vue?vue&type=script&lang=js"
export * from "./CertDetailDec2025Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__